import request from '../utils/request';
//数据
export function toMockExamList(data) {
  return request({
    url: 'wap/tyExam/toMockExamList.do',
    method: 'post',
    data
  })
}

//获取考试数据
export function toJoinExam(data) {
  return request({
    url: '/wap/tyExam/examPractice.do',
    method: 'post',
    data
  })
}

//获取班级考试数据
export function toExamUQDetail(data) {
  return request({
    url: '/wap/userQuiz/toExamUQDetail.do',
    method: 'post',
    data
  })
}

//判断是否能考试
export function findUQState(data) {
  return request({
    url: '/wap/userQuiz/findUQState.do',
    method: 'post',
    data
  })
}

//获取试卷
export function studyToJoinExam(data) {
  return request({
    url: '/wap/userQuiz/toJoinExam.do',
    method: 'post',
    data
  })
}


//提交试卷
export function handInNew(data) {
  return request({
    url: '/wap/userQuiz/handInNew.do',
    method: 'post',
    data
  })
}

//记录试卷
export function handIn(data) {
  return request({
    url: '/wap/userQuiz/handIn.do',
    method: 'post',
    data
  })
}

//买模拟联系
export function toGenerateOrderByMockId(data) {
  return request({
    url: 'wap/tyOrder/toGenerateOrderByMockId.do',
    method: 'post',
    data
  })
}


